import React from 'react';
import type { PlanTier } from '../graphql/generated/graphql';
import PricingCheckIcon from './PricingCheckIcon';
import { PlanFeatureKeysOrdered, PlanFeatures } from './PricingConfig';
import PricingModalLine from './PricingModalLine';
import * as styles from './PricingModalMobileSection.module.scss';

interface MobileRowProps {
  title: string;
  children: string | boolean;
}

const MobileRow = ({ title, children }: MobileRowProps) => {
  return (
    <div className={styles.mobilePricingRow}>
      <span>{title}</span>
      {typeof children === 'string' && <span>{children}</span>}
      {typeof children === 'boolean' && (
        <>{children ? <PricingCheckIcon /> : <PricingModalLine />}</>
      )}
    </div>
  );
};

interface PricingModalMobileSectionProps {
  name: string;
  active?: boolean;
  tier: PlanTier;
}

const PricingModalMobileSection = ({
  name,
  active,
  tier,
}: PricingModalMobileSectionProps) => {
  return (
    <div className={styles.mobilePricing}>
      <div className={styles.mobilePricingLabel}>{name}</div>
      {PlanFeatureKeysOrdered.map((key) => (
        <MobileRow key={key} title={PlanFeatures[key].name}>
          {PlanFeatures[key][tier]}
        </MobileRow>
      ))}
      {active && (
        <div className={styles.mobilePricingActivePlan}>
          This is your team&apos;s current plan
        </div>
      )}
    </div>
  );
};

export default PricingModalMobileSection;
